// client/src/pages/BlogBuilder.jsx
import React, { useState } from 'react';
import axios from 'axios';
import GeneratorForm from '../components/GeneratorForm';
import OutputDisplay from '../components/OutputDisplay';
import '../App.css';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import PageHelmet from '../components/PageHelmet';
import { normalizeRoute } from '../utils/routeHelpers';
const BlogBuilder = () => {
    // Head handled via PageHelmet
    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

        const API = (process.env.REACT_APP_BACKEND_URL || '').replace(/^['"]+|['"]+$/g, '').trim().replace(/\/+$/,'');
    const generateContent = async ({ keyword, tone }) => {
        setLoading(true);
        setError('');
        setResults(null);
        
        // Ensure this URL matches your backend server's address and port
        const API_URL = `${API}/api/generate-blog`;

        try {
            const response = await axios.post(API_URL, {
                keyword,
                tone,
            });
            
            setResults(response.data);
            
        } catch (err) {
            console.error('API Call Error:', err);
            const errMsg = err.response?.data?.message || 'Server error. Check if the backend is running.';
            setError(errMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
                <div className="blogbuilder-container">
                            <PageHelmet
                                title="AI Blog Builder — Drafts & Outlines | OneAIHuman"
                                description="Create blog outlines, headlines, and first-draft scaffolds quickly. AI-assisted drafts designed to be edited by humans for publish-ready content."
                                canonical={window.location.origin + normalizeRoute(ROUTES.blogBuilder.path)}
                            />
                            <h1>AI Blog Builder</h1>
                            <div className="page-content" style={{ marginTop: 12, color: '#6b7280', maxWidth: 800 }}>
                                <p>
                                    The AI Blog Builder converts keywords and topic ideas into structured outlines, headline options, and section drafts. It’s designed to help writers and editors move from concept to draft faster while keeping control over tone and structure. Use the builder to create outlines, generate section prompts, and get a first-draft scaffold that a human editor can polish.
                                </p>
                                <p>
                                    This tool saves editorial time by producing organized content blueprints ready for expansion. It is especially useful for teams producing frequent blog content, newsletters, or knowledge-base articles where consistent structure and SEO minded headings matter.
                                </p>
                                <ul style={{ marginTop: 8 }}>
                                    <li>Fast headline and outline generation for rapid iteration.</li>
                                    <li>Editable section prompts that save research time.</li>
                                    <li>Integrates with existing workflows to speed content production.</li>
                                </ul>
                            </div>
            {/* Section 1: Hero and Input */}
            <div className="blogbuilder-hero">
                <h2 className="blogbuilder-title">
                    Turn Keywords into Blog Headlines & Outlines Instantly
                </h2>
                <p className="blogbuilder-subtitle">
                    AI-powered content structure & ideas for just <span className="blogbuilder-price">$1/month</span>.
                </p>
                <GeneratorForm onGenerate={generateContent} loading={loading} />
            </div>

            {/* Section 2: Output Display */}
            {loading && (
                <div className="blogbuilder-loading">
                    <div className="blogbuilder-spinner"></div>
                    <p className="blogbuilder-loading-text">AI is drafting your content structure...</p>
                </div>
            )}
            
            {error && <div className="blogbuilder-error">{error}</div>}
            
            {results && <OutputDisplay results={results} />}
            
            {/* Section 3: CTA */}
            <div className="blogbuilder-cta">
                <p className="blogbuilder-cta-title">
                    Love this tool? Unlock unlimited outlines for <span className="blogbuilder-price">$1/month</span>.
                </p>
                <button 
                    onClick={() => alert("Subscription page coming soon!")}
                    className="blogbuilder-cta-btn"
                >
                    Go Pro - $1/month
                </button>
                                {/* Internal outgoing links (SPA) */}
                                <div style={{ marginTop: 25, textAlign: 'center' }}>
                                    <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
                                        <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
                                        <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
                                        <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact Us</Link>
                                    </div>
                                </div>
</div>

        </div>
    );
};

export default BlogBuilder;